import { defineStore } from "pinia";
import type { BaseColorVariant } from "bootstrap-vue-next";

export interface ToastItem {
  id: string;
  title?: string;
  body: string;
  variant?: keyof BaseColorVariant | null;
  position?: string;
  autoHideDelay?: number;
  appendToast?: boolean;
  solid?: boolean;
}

interface State {
  toasts: ToastItem[];
}

export const useToastStore = defineStore("toast", {
  state: (): State => ({
    toasts: [] as ToastItem[],
  }),
  getters: {},
  actions: {
    addToastWithMessageAndTitle(
      title: string,
      body: string,
      variant: keyof BaseColorVariant | null = "info",
    ) {
      this.addToast({
        id: self.crypto.randomUUID(),
        title: title,
        body: body,
        appendToast: false,
        position: "top-center",
        variant: variant,
        solid: true,
      } as ToastItem);
    },
    addToast(toast: ToastItem) {
      console.debug("adding toast", toast);
      this.toasts.push(toast);
    },
    removeToast(id: string) {
      this.toasts = this.toasts.filter((toast) => toast.id !== id);
      console.debug("removed toast", id);
      console.debug("remaining toasts", this.toasts);
    },

    clear() {
      this.$reset();
    },
  },
});
